import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Form, Button } from "react-bootstrap";
import axios from "axios";
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from "react-fullscreen-loading";
import { toast } from "react-hot-toast";
import Select from "react-select";
import UserProfileSelector from "../../../Components/UserProfileSelector/UserProfileSelector";
import DocumentItems from "./documentItems";


export default function CreateDocument() {
  const navigate = useNavigate();
  const [screenloader, setScreenloader] = useState(false);
  const [documentType, setDocumentType] = useState("Quotation");
  const [currency, setCurrency] = useState("USD");
  const [clientType, setClientType] = useState("Reseller");
  const [user, setUser] = useState(null);
  const [preferredPaymentMethod, setPreferredPaymentMethod] = useState("");
  const [preferredPaymentTerm, setPreferredPaymentTerm] = useState("");
  const [documentItems, setDocumentItems] = useState([]);
  const [totals, setTotals] = useState(null);
  const [termsAndConditions, setTermsAndConditions] = useState(`a) The support team will always be available to the Client in case of any challenge faced during the installation of SPCAD and also assist in the post-installation phase.\nb) The Client will be entitled to free SPCAD updates during the license activation period.\nc) We accept payment through bank transfer. However, payment via Payoneer (Payment Gateway) is also acceptable.\nd) The reseller shall bear additional bank charges/Payoneer charges while transferring the payment.`);
  const [notes, setNotes] = useState(``);

  useEffect(() => {
    setPreferredPaymentMethod(user?.preferred_payment_method || "");
    setPreferredPaymentTerm(user?.preferred_payment_term || "");
  }, [user]);


  const handleCreateDocument = async () => {
    let errorMessage = ""
    if (!user){
      errorMessage = "Client needs to be set.\n"
    }
    if (documentItems.length < 1){
      errorMessage = errorMessage + "Atleast one item is required.\n"
    }
    if (!preferredPaymentMethod || !preferredPaymentTerm){
      errorMessage = errorMessage + "PaymentMethod and PaymentTerm are required."
    }
    if (documentItems.some(item => !item.product_id)){
      errorMessage = errorMessage + "Items must have a product.\n"
    }

    if (errorMessage !== ""){
      toast.error(errorMessage);
      return;
    }

    const payload = {
      type: documentType,
      user_profile_id: user?.id,
      payment_method: preferredPaymentMethod,
      payment_term: preferredPaymentTerm,
      document_items: documentItems?.map((item) => ({
        product_id: item.product_id,
        description: item.description,
        quantity: item.quantity,
        no_of_years: item.no_of_years,
        price: item.price,
        discount: item.discount,
        total: item.total,
      })),
      total: totals?.total,
      sub_total: totals?.sub_total,
      pra_percent: totals?.pra_percent,
      currency: currency,
      terms_and_conditions: termsAndConditions,
      notes: notes
    };

    try {
      setScreenloader(true);
      await axios.post(`${process.env.REACT_APP_API_URL}/admin/documents`, payload, {
        headers: { "Access-Token": localStorage.getItem("accessToken") },
      });
      toast.success("Document created successfully!");
      navigate("/admin/documents");
    } catch (error) {
      toast.error("Failed to create document.");
    } finally {
      setScreenloader(false);
    }
  };

  const documentOptions = [
    { value: "Quotation", label: "Quotation" },
    { value: "Invoice", label: "Invoice" },
  ];

  const currencyOptions = [
    { value: "USD", label: "USD" },
    { value: "PKR", label: "PKR" },
    { value: "EURO", label: "EURO" },
  ];
  
  const clientTypeOptions = [
    { value: "User", label: "User" },
    { value: "Reseller", label: "Reseller" },
  ];

  const paymentMethodOptions = [
    { value: "Cash", label: "Cash" },
    { value: "Card", label: "Card" },
    { value: "Bank Transfer", label: "Bank Transfer" },
  ];
  
  const paymentTermOptions = [
    { value: "Advance", label: "Advance" },
    { value: "NET 7", label: "Net 7" },
    { value: "NET 15", label: "Net 15" },
    { value: "NET 30", label: "Net 30" },
  ];
  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className="content-page-bg">
        <div className="content-page">
          <div className="content">
            <h4>Create Document</h4>
            <Card>
              <Card.Header>
                <h5>Document Info</h5>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="mb-2">
                      <label style={{ fontWeight: "bold", fontSize: "14px" }}>
                        Document type 
                      </label>
                      <Select
                        options={documentOptions}
                        value={documentOptions.find(option => option.value === documentType)}
                        onChange={(selectedOption) => setDocumentType(selectedOption.value)}
                        styles={{ fontSize: "14px", fontWeight: "bold" }}
                        placeholder="Select Document Type"
                      />
                    </div>
                    <div>
                      <label style={{ fontWeight: "bold", fontSize: "14px" }}>
                        Currency 
                      </label>
                      <Select
                        options={currencyOptions}
                        value={currencyOptions.find(option => option.value === currency)}
                        onChange={(selectedOption) => setCurrency(selectedOption.value)}
                        placeholder="Select Currency"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                  <div className="mb-2">
                      <label style={{ fontWeight: "bold", fontSize: "14px" }}>
                        Client type
                      </label>
                      <Select
                        options={clientTypeOptions}
                        value={clientTypeOptions.find(option => option.value === clientType)}
                        onChange={(selectedOption) => setClientType(selectedOption.value)}
                        placeholder="Select Client Type"
                      />
                    </div>
                    <div>
                      <label style={{ fontWeight: "bold", fontSize: "14px" }}>
                        Client
                      </label>
                      <UserProfileSelector
                        type={clientType}
                        onSelectUserProfile={(user) => setUser(user)}
                      />
                    </div>
                  </div>    
                </div>
              </Card.Body>
            </Card>

            <Card className="mt-4">
              <Card.Header>
                <h5>Client Info</h5>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  {[
                    { label: "Email", value: user?.email },
                    { label: "Designation", value: user?.designation },
                    { label: "Organization", value: user?.organization },
                    { label: "Address Line 1", value: user?.address_line_1 },
                    { label: "Address Line 2", value: user?.address_line_2 },
                    { label: "Country", value: user?.country },
                    ].map((field, index) => (
                    <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center mb-3" key={index}>
                        <label style={{ fontWeight: "bold", marginRight: "10px", minWidth: "150px" }}>
                        {field.label}:
                        </label>
                        <p className="form-control-plaintext m-0">{field.value || " "}</p>
                    </div>
                    ))}

                    {/* Preferred Payment Method */}
                    <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center mb-3">
                      <label style={{ fontWeight: "bold", marginRight: "10px", minWidth: "150px" }}>
                          Preferred Payment Method:
                      </label>
                      <Select
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            minWidth: "250px",
                          }),
                        }}
                        options={paymentMethodOptions}
                        value={paymentMethodOptions.find(option => option.value === preferredPaymentMethod)}
                        onChange={(selectedOption) => setPreferredPaymentMethod(selectedOption.value)}
                        placeholder="Select Payment Method"
                      />
                    </div>

                    {/* Preferred Payment Term */}
                    <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center mb-3">
                      <label style={{ fontWeight: "bold", marginRight: "10px", minWidth: "150px" }}>
                          Preferred Payment Term:
                      </label>
                      <Select
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            minWidth: "250px",
                          }),
                        }}
                        options={paymentTermOptions}
                        value={paymentTermOptions.find(option => option.value === preferredPaymentTerm)}
                        onChange={(selectedOption) => setPreferredPaymentTerm(selectedOption.value)}
                        placeholder="Select Payment Term"
                      />
                    </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="mt-4">
              <Card.Header>
                <h5>Document Items</h5>
              </Card.Header>
              <Card.Body>
                <DocumentItems
                  documentType={documentType}
                  documentItems={documentItems}
                  setDocumentItems={setDocumentItems}
                  setTotals={setTotals}
                />
              </Card.Body>
            </Card>

            

            {documentType == "Invoice" ? 
              <Card className="mt-4">
                <Card.Header>
                  <h5>Notes</h5>
                </Card.Header>
                  <div className="">
                  <Form.Control
                    as="textarea"
                    rows={1} // Start with 1 row
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    onInput={(e) => {
                      e.target.style.height = "auto"; // Reset height
                      e.target.style.height = `${e.target.scrollHeight}px`; // Adjust height dynamically
                    }}
                    ref={(el) => {
                      if (el) {
                        el.style.height = "auto"; // Reset height
                        el.style.height = `${el.scrollHeight}px`; // Adjust height on initial load
                      }
                    }}
                    style={{ overflow: "hidden", resize: "none" }} // Prevent scrollbar, disable manual resize
                  />
                  </div>
              </Card>
              : 
              <Card className="mt-4">
              <Card.Header>
                <h5>Terms and Conditions</h5>
              </Card.Header>
                <div className="">
                <Form.Control
                  as="textarea"
                  rows={1} // Start with 1 row
                  value={termsAndConditions}
                  onChange={(e) => setTermsAndConditions(e.target.value)}
                  onInput={(e) => {
                    e.target.style.height = "auto"; // Reset height
                    e.target.style.height = `${e.target.scrollHeight}px`; // Adjust height dynamically
                  }}
                  ref={(el) => {
                    if (el) {
                      el.style.height = "auto"; // Reset height
                      el.style.height = `${el.scrollHeight}px`; // Adjust height on initial load
                    }
                  }}
                  style={{ overflow: "hidden", resize: "none" }} // Prevent scrollbar, disable manual resize
                />
                </div>
            </Card>
            }
            <div className="mt-4 text-end">
            <button
              onClick={handleCreateDocument}
              className="btn text-white admin-btn"
            >
              Create {documentType}
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
